export default "__VITE_ASSET__a2gWjSgE__"